/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface TvlResponse
 */
export interface TvlResponse {
  /**
   *
   * @type {string}
   * @memberof TvlResponse
   */
  tvlInUsd?: string
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof TvlResponse
   */
  tvlInUsdByChain?: { [key: string]: string }
  /**
   *
   * @type {string}
   * @memberof TvlResponse
   */
  maxSupply?: string
  /**
   *
   * @type {string}
   * @memberof TvlResponse
   */
  totalSupply?: string
  /**
   *
   * @type {string}
   * @memberof TvlResponse
   */
  circulatingSupply?: string
  /**
   *
   * @type {string}
   * @memberof TvlResponse
   */
  totalBurned?: string
  /**
   *
   * @type {string}
   * @memberof TvlResponse
   */
  marketCap?: string
}

export function TvlResponseFromJSON(json: any): TvlResponse {
  return TvlResponseFromJSONTyped(json, false)
}

export function TvlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TvlResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    tvlInUsd: !exists(json, 'tvlInUsd') ? undefined : json['tvlInUsd'],
    tvlInUsdByChain: !exists(json, 'tvlInUsdByChain') ? undefined : json['tvlInUsdByChain'],
    maxSupply: !exists(json, 'maxSupply') ? undefined : json['maxSupply'],
    totalSupply: !exists(json, 'totalSupply') ? undefined : json['totalSupply'],
    circulatingSupply: !exists(json, 'circulatingSupply') ? undefined : json['circulatingSupply'],
    totalBurned: !exists(json, 'totalBurned') ? undefined : json['totalBurned'],
    marketCap: !exists(json, 'marketCap') ? undefined : json['marketCap'],
  }
}

export function TvlResponseToJSON(value?: TvlResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    tvlInUsd: value.tvlInUsd,
    tvlInUsdByChain: value.tvlInUsdByChain,
    maxSupply: value.maxSupply,
    totalSupply: value.totalSupply,
    circulatingSupply: value.circulatingSupply,
    totalBurned: value.totalBurned,
    marketCap: value.marketCap,
  }
}
